module.exports = __webpack_public_path__ + "static/media/logo-small.78e03a0b.png";